import { useState, useEffect } from "react";
import { loginUser } from "../lib/LoginServerCalls";
import { validateLogin } from "../lib/validateLogin";
const initialErrors = {
  idbg: "",
  pin: "",
  serverURL: "",
  form: "",
};
const useLogin = (
  URL,
  navigate,
  setInitTabStructAndComplex,
  setActiveComposition,
  changeUserData
) => {
  const [loginError, setLoginError] = useState(initialErrors);

  const signIn = async (idbg, pin, serverURL) => {
    const testFormInputs = validateLogin(idbg, pin, serverURL);

    if (testFormInputs.valid === false) {
      setLoginError(testFormInputs.errors);
      return;
    }
    try {
      // Step 1: Attempt login
      const res = await loginUser(URL, idbg, pin, serverURL);
      changeUserData(res);

      // Only navigate if everything succeeds
      navigate("/dashboard");
    } catch (error) {
      console.error("Error during login process:", error);
      setLoginError((prev) => ({ ...prev, form: "Login failed" }));
      setTimeout(
        () => setLoginError((prev) => ({ ...prev, form: "Login failed" })),
        2000
      );
    }
  };
  useEffect(() => {
    // Postavljamo tajmer
    const timeoutId = setTimeout(() => {
      setLoginError(initialErrors);
    }, 2000);

    // Funkcija za čišćenje, koja će očistiti tajmer ako se komponenta ažurira ili demontira
    return () => clearTimeout(timeoutId);
  }, [loginError]);

  return { signIn, loginError };
};

export default useLogin;
